/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SharedTrackingContainer_user$ref = any;
export type PdpSharedLayout_user$ref = any;
export type PdpSharedLayout_user = {
    readonly " $fragmentRefs": SharedTrackingContainer_user$ref;
    readonly " $refType": PdpSharedLayout_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedLayout_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SharedTrackingContainer_user",
      "args": null
    }
  ]
};
(node as any).hash = '4d055eca3cf7a8b680bf82157ea283dc';
export default node;
